var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.value === true)?_c('i',{staticClass:"fas fa-check-circle text-success"}):_c('i',{staticClass:"fas fa-times-circle text-danger"})])
}
var staticRenderFns = []

export { render, staticRenderFns }